<template>
  <az-call-to-action dark
                     :active="true"
                     :outline="false"
                     @click="acessarEdocs">
    Edocs
  </az-call-to-action>
</template>

<script>
import {mapState} from 'vuex'
import router from "@/router";
export default {
  name: 'LicitacaoAtualizacaoAcoesEdocs',
  computed: {
    ...mapState(['licitacao'])
  },
  methods:{
    acessarEdocs(){
      router.push({name: 'edocs', params: {id: this.licitacao.id}})
    }
  }
}
</script>